import { Component, Input } from '@angular/core';
import { AppIcon, AppIconColor, AppIconSize } from '@tablesready/frontend-icons';

import { FloorPlanPartyType } from '@tablesready/frontend-timeline';

@Component({
  selector: 'tablesready-table-time',
  templateUrl: './table-time.component.html',
  styleUrls: ['./table-time.component.scss'],
})
export class TableTimeComponent {
  @Input() type = FloorPlanPartyType.booked;
  @Input() quotedTime = 0;
  @Input() seatedTime = 0;
  @Input() checkInTime = 0;
  @Input() duration = 0;
  @Input() colorClass = 'time-light';
  @Input() iconColor = AppIconColor.primary;
  @Input() timezone = '';

  icon = AppIcon;
  size = AppIconSize;
  floorPlanPartyType = FloorPlanPartyType;
}
